const locale = require('./fileTemplateModal.i18n.json');

/*@ngInject*/
const FileTemplateModalController = function ($rootScope, $scope, coreConstant, submissionId,
                                              attachmentUtil, correspondenceFormId, collaborationMediator, currentSubmissionModel,
                                              loadingBarHandler, formViewerModel, attachmentMediator) {

    $scope.i18n = locale;
    $scope.title = $scope.i18n.title;
    $scope.previewButton = $scope.i18n.previewButton;
    $scope.cancelButton = $scope.i18n.cancelButton;
    $scope.formId = correspondenceFormId;
    $scope.submissionId = submissionId;
    $scope.attachment = null;
    $scope.displayAttachmentViewer = false;
    $scope.effectiveDate = currentSubmissionModel.getCurrentSubmission().effectiveDate;
    $scope.currencyCode = currentSubmissionModel.getCurrentSubmission().currencyCode;
    $scope.okButtonClass = 'previewButton';

    $scope.viewModel = {
        attachmentId: '',
        attachmentName: '',
        isHTMLDocument: false,
        attachmentLinkURL: ''
    };

    $scope.canEnablePreviewButton = function () {
        if ($scope.displayAttachmentViewer) {
            return true;
        } else {
            let formStructure = formViewerModel.getFormStructure($scope.formId);
            if (formStructure && formStructure.formModel && formStructure.formModel.totalRequiredFieldCount === 0) {
                return true;
            }
            return false;
        }
    };

    $scope.onPreviewClicked = function () {
        if ($scope.displayAttachmentViewer) {
            $scope.displayAttachmentViewer = false;
            $scope.previewButton = $scope.i18n.previewButton;
            $scope.saveButton = '';
            $scope.okButtonClass = 'previewButton';
        } else {
            loadingBarHandler.showLoadingBar($scope.i18n.loadingBar);
            collaborationMediator.generateLetter($scope.submissionId, $scope.formId).then(function (attachment) {
                loadingBarHandler.hideLoadingBar();
                $scope.displayAttachmentViewer = true;
                $scope.attachment = attachment;
                $scope.viewModel.attachmentName = attachment.name;
                $scope.viewModel.attachmentId = attachment.id;
                $scope.previewButton = $scope.i18n.backButton;
                $scope.saveButton = $scope.i18n.saveButton;
                $scope.okButtonClass = 'backButton';
            });
        }
    };

    $scope.onSave = function () {
        loadingBarHandler.showFadingNotificationLoadingBar($scope.i18n.saveLoadingBar);
        $scope.attachment.temporary = false;
        $scope.attachment.ownerUri = 'com.firstbest.underwriting.submission.Submission:' + $scope.submissionId;
        attachmentMediator.updateAttachment($scope.attachment.id, $scope.attachment).then(function () {
            loadingBarHandler.concludeNotificationLoadingBar($scope.i18n.saveSuccessLoadingBar);
            $scope.$dismiss();
        });
    };

    $scope.onCancel = function () {
        $scope.$dismiss();
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('gw-um-submission')
    .controller('fileTemplateModalController', FileTemplateModalController);
